import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { AddressValidationSchema } from '@pages/Warehouses/data/validation';

import { IFormValues } from './interfaces';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IFormValues> =>
  Yup.object().shape({
    epd_enabled: Yup.boolean(),
    address: AddressValidationSchema(t).optional(),
    name: Yup.string().required(t('required')),
    wms_base_url: Yup.string(),
    wms_api_key: Yup.string(),
  });
